var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('overview',{on:{"on-search":_vm.onSearch}}),_c('CountTotal',{attrs:{"search":_vm.search}}),_c('TablesView',{attrs:{"search":_vm.search}}),_c('AreaView',{attrs:{"search":_vm.search}}),_c('div',{staticStyle:{"height":"10px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }